import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const txt = (i) => (typeof i === "string" ? i : [i.cari, i.neden].filter(Boolean).join(" · "));

export function TodaySummaryCard() {
  const { can } = useAuth();
  const nav = useNavigate();
  const [r, setR] = useState(undefined);
  const ok = can("ai_ozet", "all");
  useEffect(() => { if (ok) api.get("/ai-ozet/latest", { params: { kind: "gunluk" } }).then(({ data }) => setR(data)).catch(() => setR(null)); }, [ok]);
  if (!ok || !r) return null;
  const items = [...(r.ai.content?.yorum || []).slice(0, 2), ...(r.ai.content?.oneriler || []).slice(0, 2)];
  return (
    <button onClick={() => nav(`/ai-ozetler?id=${r.id}`)} data-testid="dashboard-today-summary"
      className="panel w-full text-left p-4 mb-4 border-l-4 border-l-violet-500 transition-shadow hover:shadow-md">
      <div className="flex items-center gap-2 text-[13px] font-semibold mb-2">
        <Sparkles className="h-4 w-4 text-violet-600" />Bugünün Özeti<span className="text-[11px] font-normal text-slate-500">{r.title}</span>
        <ChevronRight className="h-4 w-4 ml-auto text-slate-400" />
      </div>
      <ul className="grid md:grid-cols-2 gap-x-6 gap-y-1">{items.map((i, n) => <li key={n} className="text-[12px] text-slate-700 flex gap-2"><span className="text-violet-500">•</span>{txt(i)}</li>)}</ul>
    </button>
  );
}
